import React, { useState } from "react";
import Dropzone from "react-dropzone";
import { TbCloudUpload } from "react-icons/tb";
import { AiOutlinePlus } from "react-icons/ai";
import { BiCheck } from "react-icons/bi";
import { TiArrowSortedDown } from "react-icons/ti";
import { TiArrowSortedUp } from "react-icons/ti";
import { FaTimes } from "react-icons/fa";
import Switch from "./Switch";
import DiscoverItem from "../common/DiscoverItem";
import { toast, ToastContainer } from "react-toastify";
import useAuth from "../../Hooks/useAuth";

const UploadItem = () => {
  const {showDummyImage} = useAuth()
  const [value, setValue] = useState(false);
  const [uploadedImage, setUploadedImage] = useState();
  const [uploadedItem,setUploadedItem] = useState({
    id: 1,
    profileImg: "user_1.png",
    profileName: "Myrwyn Braybrook",
    title: "",
    image:"",
    timeline: "10:3:2021",
    category: "Cartoon",
    price: "3.61",
    status: true,
    currency: "ETH",
    userId: "@thesalvare",
    description:
      "",
    creation: "60",
    follower: "100k",
    following: "85k",
  });
  const setInput = (e) => {
    let value = e.target.value;
    setUploadedItem({...uploadedItem,[e.target.name]:value})
  }
  const submitItem = (e) => {
    e.preventDefault()
    if (!uploadedItem.title || !uploadedItem.description) {
      toast.error('Please set title and description', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        });
    } else {
      setUploadedItem({
        ...uploadedItem,
        image: uploadedImage
    })
    }

  }

  return (
    <section className="upload-item">
      <div>
        <ToastContainer />
      </div>
      <div className="container">
        <h2 className="pageTitle">
          Upload iteam detai<span>ls</span>
        </h2>
        <div className="upload-item-wrapper">
          <div className="upload-item-left">
            <div className="upload-here">
              <h4>Upload file</h4>
              <p>Drag or choose your file to upload.</p>
              {uploadedImage ? (
                <div className="upload-img">
                  <img src={uploadedImage} alt={uploadedImage} />
                  <span
                    className="remove-img"
                    onClick={() => {
                      setUploadedImage("");
                    }}
                  >
                    <FaTimes />
                  </span>
                </div>
              ) : (
                <Dropzone
                  onDrop={(acceptedFiles) =>
                    setUploadedImage(URL.createObjectURL(acceptedFiles[0]))
                  }
                >
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()} className="drag-and-drop">
                      <input {...getInputProps()} />
                      <TbCloudUpload className="drag-and-drop-icon" />
                      <label>Drag and drop or browse to choose a file</label>
                    </div>
                  )}
                </Dropzone>
              )}
            </div>
            <form onSubmit={submitItem}>
              <div className="iteams-details">
                <div className="describe-item">
                  <h4>Iteam detils</h4>
                  <p>Describe your iteam in details.</p>
                </div>
                <div className="upload-form">
                  <div className="upload-form-input">
                    <label htmlFor="">Title</label>
                    <input type="text" placeholder="e.g Fluffy Pank" name="title" onChange={setInput}/>
                  </div>
                  <div className="upload-form-input">
                    <label htmlFor="">Descroption</label>
                    <textarea
                      type="text"
                      placeholder="e.g. After purchasing you will able to recived the artwork"
                      name="description"
                      onChange={setInput}
                    ></textarea>
                  </div>
                  <div className="upload-form-input royalties">
                    <label htmlFor="">Royalties</label>
                    <div className="royalties-input">
                      <div className="input-with-btn">
                        <input type="number" placeholder="10%" />
                        <div className="input-box-btn">
                          <button className="increment" type="button">
                            <TiArrowSortedUp />
                          </button>
                          <button className="decrement" type="button">
                            <TiArrowSortedDown />
                          </button>
                        </div>
                      </div>
                      <input type="text" placeholder="e.g. Size" />
                      <input type="text" placeholder="e.g.  Propertie" />
                    </div>
                  </div>
                  <div className="timed-action">
                    <h4>Timed auction</h4>
                    <p>Set a period of time for which buyers can place bids</p>
                    <div className="timed-action-inputs">
                      <div className="timed-action-input">
                        <label htmlFor="">Starting Date</label>
                        <div className="input-with-btn">
                          <input type="text" placeholder="23/07/2022  07:00 PM" />
                          <div className="input-box-btn">
                            <button className="increment" type="button">
                              <TiArrowSortedUp />
                            </button>
                            <button className="decrement" type="button">
                              <TiArrowSortedDown />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="timed-action-input">
                        <label htmlFor="">Expiration Date</label>
                        <div className="input-with-btn">
                          <input type="text" placeholder="25/07/2022  07:00 PM" />
                          <div className="input-box-btn">
                            <button className="increment" type="button">
                              <TiArrowSortedUp />
                            </button>
                            <button type="button" className="decrement">
                              <TiArrowSortedDown />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p>
                      Any bid placed in the last 10 minutes extends the auction by
                      10 minutes.
                    </p>
                  </div>
                  <div className="upload-actions">
                    <div className="upload-action">
                      <div className="upload-action-left">
                        <h4>Put on sale</h4>
                        <p>You’ll receive bids on this iteam.</p>
                      </div>

                      <div className="upload-action-right">
                        <Switch
                          isOn={value}
                          onColor="#f63f7d"
                          handleToggle={() => setValue(!value)}
                        />
                      </div>
                    </div>
                    
                    <div className="upload-action">
                      <div className="upload-action-left">
                        <h4>Put on sale</h4>
                        <p>You’ll receive bids on this iteam.</p>
                      </div>
                      <div className="upload-action-right">
                        <Switch
                          isOn={value}
                          onColor="#f63f7d"
                          handleToggle={() => setValue(!value)}
                        />
                      </div>
                    </div>
                    <div className="upload-action">
                      <div className="upload-action-left">
                        <h4>Put on sale</h4>
                        <p>You’ll receive bids on this iteam.</p>
                      </div>
                      <div className="upload-action-right">
                        <Switch
                          isOn={value}
                          onColor="#f63f7d"
                          handleToggle={() => setValue(!value)}
                        />
                      </div>
                    </div>
                    <div className="choose-collection">
                      <h4>Choose Collection</h4>
                      <p>Choose an exiting collection or create a new one.</p>
                      <div className="add-collection">
                        <div className="add-collection-item">
                          <div className="add-collection-user">
                            <AiOutlinePlus className="add-collection-user-icon" />
                          </div>
                          <span>Add new</span>
                        </div>
                        <div className="add-collection-item">
                          <div className="add-collection-user">
                            <img src={require("../../assets/images/common/owner.png")} alt={'owner'} onError={({currentTarget},imageSize='30X30')=>showDummyImage({currentTarget},imageSize)}/>
                          </div>
                          <span>Caterry</span>
                        </div>
                        <div className="add-collection-item">
                          <div className="add-collection-user">
                            <img src={require("../../assets/images/common/owner.png")} alt={'owner'} onError={({currentTarget},imageSize='30X30')=>showDummyImage({currentTarget},imageSize)}/>
                          </div>
                          <span>TheSeries</span>
                        </div>
                      </div>
                    </div>
                    <div className="upload-work-btn">
                      <button>Create iteam</button>
                      <div className="save-just-now">
                        <div className="save-just-now-icon">
                          <BiCheck />
                        </div>
                        <span>Save just now</span>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </form>
          </div>
          {
            uploadedItem?.image && <div className="upload-item-right">
            <h4>Preview now</h4>
            <p>Preview now upload your products </p>
            <DiscoverItem data={uploadedItem} />
          </div>
          }
          
        </div>
      </div>
    </section>
  );
};

export default UploadItem;
